import React, { useState, useEffect } from 'react';
import PiPrice from './PiPrice';

function InvoiceModal({ entry, onClose }) {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '20px 12px', overflowY: 'auto' }} onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 16, maxWidth: 420, width: '100%', padding: '1.5rem', marginTop: 20 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>🧾 Invoice</h2>
          <button onClick={onClose} style={{ border: 'none', background: 'transparent', fontSize: 20, cursor: 'pointer', color: '#5F5E5A' }}>✕</button>
        </div>
        {entry.invoice_number && (
          <p style={{ fontSize: 11, color: '#999', fontFamily: 'monospace', marginBottom: 16 }}>{entry.invoice_number}</p>
        )}

        <div style={{ textAlign: 'center', marginBottom: 20, paddingBottom: 16, borderBottom: '1px dashed #E3E1D9' }}>
          <div style={{ fontSize: 32, marginBottom: 6 }}>{entry.icon}</div>
          <p style={{ fontSize: 15, fontWeight: 600, margin: '0 0 2px' }}>{entry.title}</p>
          <p style={{ fontSize: 12, color: '#5F5E5A', margin: 0 }}>{entry.app}</p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F1EFE8' }}>
          <span style={{ fontSize: 13, color: '#5F5E5A' }}>Amount Paid</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: '#0F6E56' }}><PiPrice pi={entry.amount_pi} /></span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F1EFE8' }}>
          <span style={{ fontSize: 13, color: '#5F5E5A' }}>Date</span>
          <span style={{ fontSize: 13 }}>{new Date(entry.date).toLocaleString()}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F1EFE8' }}>
          <span style={{ fontSize: 13, color: '#5F5E5A' }}>Status</span>
          <span style={{ fontSize: 13, fontWeight: 600, textTransform: 'capitalize' }}>{entry.status}</span>
        </div>
        {entry.tracking_code && (
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F1EFE8' }}>
            <span style={{ fontSize: 13, color: '#5F5E5A' }}>Reference / Tracking Code</span>
            <span style={{ fontSize: 13, fontWeight: 600, fontFamily: 'monospace' }}>{entry.tracking_code}</span>
          </div>
        )}

        {entry.note && (
          <p style={{ fontSize: 11, color: '#999', fontStyle: 'italic', marginTop: 14 }}>ℹ️ {entry.note}</p>
        )}

        <p style={{ fontSize: 10, color: '#999', textAlign: 'center', marginTop: 16 }}>
          This is a summary generated from your account activity, not an official tax receipt.
        </p>
      </div>
    </div>
  );
}

export default function MyTransactions({ user }) {
  const [data, setData] = useState(null);
  const [filterApp, setFilterApp] = useState('');
  const [selectedEntry, setSelectedEntry] = useState(null);

  useEffect(() => {
    if (!user) return;
    fetch('/api/my-transactions/', {
      headers: { Authorization: `Token ${user.token}` },
    })
      .then((r) => r.json())
      .then(setData)
      .catch(() => setData({ entries: [], total_spent_pi: 0 }));
  }, [user]);

  if (!user) return <div style={{ padding: 20, textAlign: 'center' }}><h2>🔑 Login Required</h2></div>;
  if (!data) return <div style={{ padding: 20, textAlign: 'center', color: '#999' }}>Loading your transactions...</div>;

  const apps = [...new Set(data.entries.map((e) => e.app))];
  const filtered = filterApp ? data.entries.filter((e) => e.app === filterApp) : data.entries;

  const statusColor = (status) => {
    if (['paid', 'completed', 'active', 'boosted', 'premium', 'delivered'].includes(status)) return '#0F6E56';
    if (['pending', 'processing'].includes(status)) return '#91600C';
    if (['cancelled', 'disputed', 'rejected'].includes(status)) return '#A32D2D';
    return '#5F5E5A';
  };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif' }}>
      {selectedEntry && <InvoiceModal entry={selectedEntry} onClose={() => setSelectedEntry(null)} />}

      <h1 style={{ fontSize: 22, marginBottom: 4 }}>🧾 My Transactions</h1>
      <p style={{ fontSize: 13, color: '#5F5E5A', marginBottom: 16 }}>
        Every purchase and payment you've made across all apps, in one place. Tap any entry for details.
      </p>

      <div style={{ background: '#E1F5EE', borderRadius: 12, padding: '1rem', marginBottom: 16, textAlign: 'center' }}>
        <p style={{ fontSize: 12, color: '#5F5E5A', margin: '0 0 4px' }}>Total Spent</p>
        <p style={{ fontSize: 24, fontWeight: 700, color: '#0F6E56', margin: 0 }}><PiPrice pi={data.total_spent_pi} /></p>
      </div>

      {apps.length > 1 && (
        <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
          <button onClick={() => setFilterApp('')} style={{ padding: '5px 12px', fontSize: 12, borderRadius: 14, border: '1px solid #E3E1D9', background: filterApp === '' ? '#0F6E56' : '#fff', color: filterApp === '' ? '#fff' : '#5F5E5A', cursor: 'pointer' }}>All</button>
          {apps.map((a) => (
            <button key={a} onClick={() => setFilterApp(a)} style={{ padding: '5px 12px', fontSize: 12, borderRadius: 14, border: '1px solid #E3E1D9', background: filterApp === a ? '#0F6E56' : '#fff', color: filterApp === a ? '#fff' : '#5F5E5A', cursor: 'pointer' }}>{a}</button>
          ))}
        </div>
      )}

      {filtered.length === 0 ? (
        <p style={{ textAlign: 'center', color: '#999', padding: '3rem 0' }}>No transactions yet.</p>
      ) : (
        filtered.map((e, i) => (
          <div
            key={i}
            onClick={() => setSelectedEntry(e)}
            style={{ background: '#fff', border: '1px solid #E3E1D9', borderRadius: 10, padding: '0.85rem 1rem', marginBottom: 8, cursor: 'pointer' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p style={{ fontSize: 13, fontWeight: 500, margin: '0 0 2px' }}>{e.icon} {e.title}</p>
                <p style={{ fontSize: 11, color: '#5F5E5A', margin: 0 }}>
                  {e.app} · {new Date(e.date).toLocaleDateString()} {e.tracking_code && `· ${e.tracking_code}`}
                </p>
                {e.invoice_number && (
                  <p style={{ fontSize: 10, color: '#999', fontFamily: 'monospace', margin: '2px 0 0' }}>{e.invoice_number}</p>
                )}
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: 14, fontWeight: 600, color: '#0F6E56', margin: '0 0 2px' }}><PiPrice pi={e.amount_pi} /></p>
                <p style={{ fontSize: 10, fontWeight: 600, color: statusColor(e.status), margin: 0, textTransform: 'capitalize' }}>{e.status}</p>
              </div>
            </div>
            {e.note && <p style={{ fontSize: 10, color: '#999', margin: '6px 0 0', fontStyle: 'italic' }}>ℹ️ {e.note}</p>}
          </div>
        ))
      )}
    </div>
  );
}
